var map = {
	"./de.json": 76130,
	"./en.json": 343425,
	"./es.json": 939643,
	"./fr.json": 493348,
	"./it.json": 129634,
	"./ja.json": 742852,
	"./ko.json": 120416,
	"./pl.json": 60890,
	"./pt.json": 639891,
	"./ru.json": 866152,
	"./uk.json": 714730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 725040;